<div class="p-3">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <h5 class="mb-0">Add New Wallet</h5>
    <img
      src="assets/images/close-icon.svg"
      alt="close-icon"
      class="cursor-pointer"
      [attr.aria-hidden]="true"
      (click)="closeDialogRef.close(false)" />
  </div>

  <form class="mat-form" [formGroup]="addWalletForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-12 form-group">
        <app-input-select
          *appHasPlatformAccess
          (selectionChange)="onPartnerChange($event)"
          [inputData]="attrConstant.partner"
          [selectOptions]="data.partnerList | async"
          [bindLabel]="'name'"
          [bindValue]="'partner_id'"
          [formControlName]="attrConstant.partner.key"></app-input-select>
        <app-input-select
          *ngIf="!data.isSuperAdmin"
          [inputData]="attrConstant.sender"
          [selectOptions]="data.senderList"
          [bindLabel]="'sender_name'"
          [bindValue]="'sender_id'"
          [formControlName]="attrConstant.sender.key"></app-input-select>
        <app-input-select
          (selectionChange)="onSourceCountryChange($event)"
          [inputData]="attrConstant.country"
          [selectOptions]="sourceCountryList"
          [bindLabel]="'countryName'"
          [bindValue]="'countryCode'"
          [formControlName]="attrConstant.country.key"></app-input-select>
        <app-input-template
          [inputData]="attrConstant.currency"
          [formControlName]="attrConstant.currency.key"></app-input-template>
      </div>
    </div>
    <div class="row mt-3 justify-content-end">
      <div class="col-md-6">
        <button
          class="btn primary-btn w-100"
          [ngClass]="isSubmitLoading ? 'dsbld' : 'enbld'">
          <img
            *ngIf="isSubmitLoading"
            src="assets/images/button-spinner.svg"
            alt="button-spinner" />Add
        </button>
      </div>
    </div>
  </form>
</div>
